import { Cookies } from 'react-cookie';

import { AddPlanFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface CreatePlanProps {
  plan: AddPlanFormValues;
  slug: string;
}

export const postNewPlan = async ({ plan, slug }: CreatePlanProps) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const data = await axiosInterceptor.post(`/v1/objects/${slug}/plans/`, plan, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data as any;
};
